import {useEffect,useState} from 'react';
let pending;
export function useCapabilities(){
  const [value,setValue]=useState(null);
  useEffect(()=>{
    let alive=true;
    if(!pending)pending=fetch('/api/capabilities').then(r=>{if(!r.ok)throw new Error('Unavailable');return r.json();}).catch(()=>{pending=null;return null;});
    pending.then(v=>{if(alive)setValue(v);});
    return()=>{alive=false;};
  },[]);
  return value;
}
